import { useEffect, useState } from "react";
import { Flask, SignOut } from "@phosphor-icons/react";

const mmss = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

// Always on screen during a staff AI test, so nobody mistakes it for real ordering.
export function StaffTestBanner({ staffTest, onEnd }) {
  const [left, setLeft] = useState(staffTest.seconds_left);
  useEffect(() => {
    const end = Date.now() + staffTest.seconds_left * 1000;
    const t = setInterval(() => {
      const s = Math.max(Math.round((end - Date.now()) / 1000), 0);
      setLeft(s);
      if (s === 0) { clearInterval(t); onEnd(); }
    }, 1000);
    return () => clearInterval(t);
  }, [staffTest.seconds_left]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="relative z-40 flex flex-wrap items-center gap-x-4 gap-y-2 bg-[#ffd166] text-[#3d2a00] px-4 sm:px-8 py-2 text-sm" data-testid="staff-test-banner">
      <Flask size={20} weight="fill" />
      <b className="tracking-wide">STAFF AI TEST MODE</b>
      <span className="min-w-0 flex-1">No real orders, payments, stock changes or receipts. AI voice use is still charged to your AI balance.{staffTest.by ? ` Started by ${staffTest.by}.` : ""}</span>
      <span className="font-mono tabular-nums" data-testid="staff-test-time-left">{mmss(left)}</span>
      <button className="kiosk-pill !h-9 bg-[#3d2a00] text-white" data-testid="staff-test-exit" onClick={onEnd}><SignOut size={16} /> Exit test mode</button>
    </div>
  );
}
